import JQuery from "jquery";
import { LoginContext } from "./types/LoginContext";
import "../../../resources/less/Admin/Login/TroubLoginPopup.less";

export default class VLoginPopup {
  // Main containers
  public readonly stepContainers: JQuery<HTMLElement>;
  // Form elements
  public readonly loginForm: JQuery<HTMLFormElement>;
  public readonly submitButton: JQuery<HTMLButtonElement>;
  // Interactive elements
  public readonly platformSelectButton: JQuery<HTMLElement>;
  public readonly backStepButton: JQuery<HTMLElement>;
  public readonly createAccountButton: JQuery<HTMLElement>;
  public readonly teacherSelectButton: JQuery<HTMLElement>;
  public readonly studentSelectButton: JQuery<HTMLElement>;
  public readonly askTeacherButton: JQuery<HTMLElement>;
  public readonly backFormButton: JQuery<HTMLElement>;
  public readonly targetMessageLink: JQuery<HTMLElement>;
  public readonly backCancelButton: JQuery<HTMLElement>;
  public readonly closeContainer: JQuery<HTMLElement>;
  // Message elements
  public readonly messageOverlays: JQuery<HTMLElement>;
  public readonly askTeacherMessage: JQuery<HTMLElement>;
  // Content areas
  public readonly loginUserForm: JQuery<HTMLElement>;
  public readonly popupFooter: JQuery<HTMLElement>;
  public readonly userTypesContainer: JQuery<HTMLElement>;

  private currentTarget: JQuery<HTMLElement>;

  constructor(currentTarget: JQuery<HTMLElement>) {
    this.currentTarget = currentTarget;

    // Main containers
    this.stepContainers = this.currentTarget.find(".step-container");

    // Form elements
    this.loginForm = this.currentTarget.find("form[name='form-signin-popup']");
    this.submitButton = this.currentTarget.find(".submit-login-button");

    // Interactive elements
    this.platformSelectButton = this.currentTarget.find(".js-platform-select");
    this.backStepButton = this.currentTarget.find(".js-back-step");
    this.createAccountButton = this.currentTarget.find(".js-create-account");
    this.teacherSelectButton = this.currentTarget.find(".js-user-teacher");
    this.studentSelectButton = this.currentTarget.find(".js-user-student");
    this.askTeacherButton = this.currentTarget.find(".js-ask-teacher");
    this.backFormButton = this.currentTarget.find(".back-form-btn");
    this.targetMessageLink = this.currentTarget.find("a[data-target-msg]");
    this.backCancelButton = this.currentTarget.find(".back-btn, .cancel-btn");
    this.closeContainer = this.currentTarget.find(".close-container");

    // Message elements
    this.messageOverlays = this.currentTarget.find(".message-overlay");
    this.askTeacherMessage = this.currentTarget.find("#ask-teacher-message");

    // Content areas
    this.loginUserForm = this.currentTarget.find("#login-popup-form");
    this.popupFooter = this.currentTarget.find("#login-popup-footer");
    this.userTypesContainer = this.currentTarget.find(
      "#login-popup-user-types",
    );
  }

  // Step Management
  public ShowStep(step: string): void {
    this.HideAllSteps();
    const stepContainer = this.stepContainers.filter(`[data-step="${step}"]`);
    stepContainer.removeClass("hide");
  }

  public HideAllSteps(): void {
    this.stepContainers.addClass("hide");
  }

  // User Type Management
  public SetUserType(userType: string): void {
    this.currentTarget.attr("data-user-type", userType.toUpperCase());
  }

  public SetContext(context: LoginContext): void {
    this.currentTarget.attr("data-context", context);
  }

  public ShowBackLink(): void {
    this.backStepButton.removeClass("hide");
  }

  public HideBackLink(): void {
    this.backStepButton.addClass("hide");
  }

  // Form Management
  public ResetForm(): void {
    this.loginForm.trigger("reset");
  }

  /** The account is known already: the school form opens on its email, the caret on the password. */
  public PrefillUsername(username: string): void {
    this.loginForm.find("[name='_username']").val(username);
    this.loginForm.find("[name='_password']").trigger("focus");
  }

  public SubmitForm(): void {
    this.loginForm.trigger("submit");
  }

  public HasValidationErrors(): boolean {
    return this.loginForm.find(".invalid-credential").length > 0;
  }

  // Message Management
  public ShowMessage(messageId: string): void {
    this.userTypesContainer.addClass("hide");
    this.loginUserForm.addClass("hide");
    this.popupFooter.addClass("hide");
    $(`#${messageId}`).removeClass("hide");
  }

  public HideMessage(messageId: string): void {
    $(`#${messageId}`).addClass("hide");
    this.userTypesContainer.removeClass("hide");
    this.loginUserForm.removeClass("hide");
    this.popupFooter.removeClass("hide");
  }

  public HideAllMessages(): void {
    this.messageOverlays.addClass("hide");
    this.userTypesContainer.removeClass("hide");
    this.loginUserForm.removeClass("hide");
    this.popupFooter.removeClass("hide");
  }

  public SetSelectedPlatform(platform: string): void {
    this.platformSelectButton.removeClass("active");
    this.platformSelectButton
      .filter(`[data-platform="${platform}"]`)
      .addClass("active");
  }
}
